export default {
  baseStyle: {
    container: {
      minHeight: '88.5px',
    },
  },
};
